export function generateQueryParams(params) {
  if (Object.keys(params).length === 0) {
    return "";
  }

  let str = "?";

  for (const [key, value] of Object.entries(params)) {
    // Array -> multiple values
    if (Array.isArray(value)) {
      value.forEach((singleArrayValue) => {
        str += `${key}[]=${encodeURIComponent(singleArrayValue)}&`;
      });
    }

    // String or number -> single value
    if (typeof value === "string" || value instanceof String || typeof value === "number") {
      str += `${key}=${encodeURIComponent(value)}&`;
    }
  }

  // Remove last &
  return str.substring(0, str.length - 1);
}
